<template>
  <a-descriptions-item :class="bem.b()" v-bind="attrs">
    <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-descriptions-item>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'

defineOptions({ name: 'LlDescriptionsItem' })

const attrs = useAttrs()

const bem = createNamespace('descriptions-item')
</script>
